import { useEffect, useState } from "react";
import { api, formatTRY, formatNum } from "@/lib/apiClient";
import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from "recharts";
import { CalendarRange } from "lucide-react";

export const ClubMonthly = ({ refreshKey }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/club/monthly", { params: { months: 6 } }).then((r) => setRows(r.data)).catch(() => setRows([])); }, [refreshKey]);
  if (!rows.length) return null;
  const style = { background: "var(--card)", border: "1px solid var(--border)", borderRadius: 12, color: "var(--foreground)" };
  return (
    <div className="rounded-xl border border-border bg-card p-4" data-testid="club-monthly">
      <h3 className="flex items-center gap-2 font-heading text-base font-semibold"><CalendarRange className="h-4 w-4 text-primary" /> Aylık Öğün ve Kâr (son 6 ay)</h3>
      <div className="mt-3 h-56" data-testid="club-monthly-chart">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={rows}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" vertical={false} />
            <XAxis dataKey="label" stroke="var(--muted-foreground)" fontSize={12} />
            <YAxis yAxisId="m" stroke="var(--muted-foreground)" fontSize={12} allowDecimals={false} />
            <YAxis yAxisId="p" orientation="right" stroke="var(--muted-foreground)" fontSize={12} tickFormatter={(v) => formatNum(v, 0)} />
            <Tooltip contentStyle={style} formatter={(v, n) => (n === "Satılan Öğün" ? `${v} öğün` : formatTRY(v))} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar yAxisId="m" dataKey="meals" name="Satılan Öğün" fill="var(--chart-1)" radius={[6, 6, 0, 0]} />
            <Line yAxisId="p" type="monotone" dataKey="profit" name="Net Kâr" stroke="var(--chart-2)" strokeWidth={2} dot={{ r: 3 }} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-2 grid grid-cols-3 gap-1 text-[11px] sm:grid-cols-6">
        {rows.map((r) => (
          <div key={r.month} className="rounded-md bg-muted/40 px-2 py-1" data-testid={`club-month-${r.month}`}>
            <p className="font-semibold">{r.label}</p>
            <p className="text-muted-foreground">{r.meals} öğün · {formatNum(r.vp, 1)} VP</p>
            <p className={r.profit >= 0 ? "text-primary" : "text-destructive"}>{formatTRY(r.profit)}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
